var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "request-log-detail-modal",
      attrs: { title: "请求日志详情", width: "1000", "mask-closable": false },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _vm.logData
        ? _c(
            "div",
            { staticClass: "log-detail" },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "Card",
                        {
                          staticClass: "info-card",
                          attrs: {
                            title: "基本信息",
                            bordered: false,
                            "dis-hover": "",
                          },
                        },
                        [
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("请求ID："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.logData.requestId || "-")),
                            ]),
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("请求时间："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDateTime(_vm.logData.timestamp)
                                )
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "info-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("HTTP方法："),
                              ]),
                              _c(
                                "Tag",
                                {
                                  attrs: {
                                    color: _vm.getMethodColor(
                                      _vm.logData.method
                                    ),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.logData.method))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "info-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("路径："),
                              ]),
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    content: _vm.logData.path,
                                    placement: "top",
                                    "max-width": "300",
                                    transfer: "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "value path-value text-truncate",
                                    },
                                    [_vm._v(_vm._s(_vm.logData.path || "-"))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("查询参数："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.logData.queryString || "-")),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "Card",
                        {
                          staticClass: "info-card",
                          attrs: {
                            title: "用户与网络信息",
                            bordered: false,
                            "dis-hover": "",
                          },
                        },
                        [
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("用户："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(_vm.logData.userName) +
                                  " (" +
                                  _vm._s(_vm.logData.userId || "-") +
                                  ")"
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("客户端IP："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(_vm.logData.remoteIpAddress || "-")
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "info-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("状态码："),
                              ]),
                              _c(
                                "Tag",
                                {
                                  attrs: {
                                    color: _vm.getStatusCodeColor(
                                      _vm.logData.responseStatusCode
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.logData.responseStatusCode) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("耗时："),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "value",
                                style: {
                                  color: _vm.getDurationColor(
                                    _vm.logData.duration
                                  ),
                                  fontWeight: "bold",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.logData.duration) +
                                    "ms\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "info-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("UA："),
                              ]),
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    content: _vm.logData.userAgent,
                                    placement: "top",
                                    "max-width": "300",
                                    transfer: "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "value user-agent text-truncate",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.logData.userAgent || "-")
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { gutter: 16 },
                },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "Card",
                        {
                          staticClass: "body-card",
                          attrs: { bordered: false, "dis-hover": "" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_c("span", [_vm._v("请求信息")])]
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                slot: "extra",
                                href: "javascript:void(0)",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showRequestBody = !_vm.showRequestBody
                                },
                              },
                              slot: "extra",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.showRequestBody ? "收起" : "展开"
                                  ) +
                                  "\n                        "
                              ),
                              _c("Icon", {
                                attrs: {
                                  type: _vm.showRequestBody
                                    ? "ios-arrow-up"
                                    : "ios-arrow-down",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "meta-info" },
                            [
                              _c("Tag", { attrs: { type: "border" } }, [
                                _vm._v(
                                  "Size: " +
                                    _vm._s(
                                      _vm.formatFileSize(
                                        _vm.logData.requestSize
                                      )
                                    )
                                ),
                              ]),
                              _vm.logData.contentType
                                ? _c(
                                    "Tag",
                                    {
                                      attrs: { type: "border", color: "blue" },
                                    },
                                    [_vm._v(_vm._s(_vm.logData.contentType))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("transition", { attrs: { name: "slide-fade" } }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showRequestBody,
                                    expression: "showRequestBody",
                                  },
                                ],
                                staticClass: "code-wrapper",
                              },
                              [
                                _vm.logData.ErrorMessage
                                  ? _c(
                                      "div",
                                      { staticClass: "info-item" },
                                      [
                                        _c(
                                          "Alert",
                                          {
                                            attrs: {
                                              type: "error",
                                              "show-icon": "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    错误信息\n                                    "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "desc" },
                                                slot: "desc",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.logData.errorMessage
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "code-box" }, [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatJson(_vm.logData.requestBody)
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "Card",
                        {
                          staticClass: "body-card",
                          attrs: { bordered: false, "dis-hover": "" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_c("span", [_vm._v("响应信息")])]
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                slot: "extra",
                                href: "javascript:void(0)",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showResponseBody = !_vm.showResponseBody
                                },
                              },
                              slot: "extra",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.showResponseBody ? "收起" : "展开"
                                  ) +
                                  "\n                        "
                              ),
                              _c("Icon", {
                                attrs: {
                                  type: _vm.showResponseBody
                                    ? "ios-arrow-up"
                                    : "ios-arrow-down",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "meta-info" },
                            [
                              _c("Tag", { attrs: { type: "border" } }, [
                                _vm._v(
                                  "Size: " +
                                    _vm._s(
                                      _vm.formatFileSize(
                                        _vm.logData.responseSize
                                      )
                                    )
                                ),
                              ]),
                              _vm.logData.responseContentType
                                ? _c(
                                    "Tag",
                                    {
                                      attrs: { type: "border", color: "green" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.logData.responseContentType)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("transition", { attrs: { name: "slide-fade" } }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showResponseBody,
                                    expression: "showResponseBody",
                                  },
                                ],
                                staticClass: "code-wrapper",
                              },
                              [
                                _c("div", { staticClass: "code-box" }, [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatJson(_vm.logData.responseBody)
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.logData && _vm.logData.curlCommand
                ? _c(
                    "Row",
                    { staticStyle: { "margin-top": "16px" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "Card",
                            { attrs: { bordered: false, "dis-hover": "" } },
                            [
                              _c(
                                "p",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v("Curl 命令")]
                              ),
                              _c(
                                "div",
                                { staticClass: "curl-command-container" },
                                [
                                  _c("pre", { staticClass: "curl-command" }, [
                                    _vm._v(_vm._s(_vm.logData.curlCommand)),
                                  ]),
                                  _c(
                                    "Button",
                                    {
                                      staticClass: "copy-btn",
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        icon: "md-copy",
                                      },
                                      on: { click: _vm.copyCurlCommand },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            复制\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.requestHeaders || _vm.responseHeaders
                ? _c(
                    "Row",
                    { staticStyle: { "margin-top": "16px" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "Card",
                            {
                              attrs: {
                                bordered: false,
                                "dis-hover": "",
                                padding: 0,
                              },
                            },
                            [
                              _c(
                                "Tabs",
                                { attrs: { animated: false } },
                                [
                                  _vm.requestHeaders
                                    ? _c(
                                        "TabPane",
                                        {
                                          attrs: {
                                            label: "请求头",
                                            name: "headers",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tab-content-wrapper",
                                            },
                                            [
                                              _c(
                                                "pre",
                                                { staticClass: "json-content" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatJson(
                                                        _vm.requestHeaders
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.responseHeaders
                                    ? _c(
                                        "TabPane",
                                        {
                                          attrs: {
                                            label: "响应头",
                                            name: "responseHeaders",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tab-content-wrapper",
                                            },
                                            [
                                              _c(
                                                "pre",
                                                { staticClass: "json-content" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatJson(
                                                        _vm.responseHeaders
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [_c("Button", { on: { click: _vm.closeModal } }, [_vm._v("关闭")])],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }